import React from 'react';
import LoginFormC from '../components/LoginFormC';

interface LoginProps {
  onLoginSuccess: (token: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  return (
    <div className="min-h-screen flex items-center justify-center py-8">
      <LoginFormC onLoginSuccess={onLoginSuccess} />
    </div>
  );
};

export default Login;
